import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useId, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Button } from '../Button/index.js';
export function ConfirmModal({ open, title, message, confirmLabel, cancelLabel, confirmVariant = 'primary', busy = false, onCancel, onConfirm, }) {
    const titleId = useId();
    const messageId = useId();
    const confirmWrapRef = useRef(null);
    const [submitted, setSubmitted] = useState(false);
    const locked = busy || submitted;
    useEffect(() => {
        if (!open) {
            setSubmitted(false);
        }
    }, [open]);
    useEffect(() => {
        if (!open) {
            return;
        }
        const onKeyDown = (event) => {
            if (event.key === 'Escape' && !locked) {
                onCancel();
            }
        };
        window.addEventListener('keydown', onKeyDown);
        const previousOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            window.removeEventListener('keydown', onKeyDown);
            document.body.style.overflow = previousOverflow;
        };
    }, [open, locked, onCancel]);
    useEffect(() => {
        if (!open) {
            return;
        }
        const confirmButton = confirmWrapRef.current?.querySelector('button');
        confirmButton?.focus();
    }, [open]);
    if (!open) {
        return null;
    }
    return createPortal(_jsxs("div", { className: "fm-confirm-modal", role: "dialog", "aria-modal": "true", "aria-labelledby": titleId, "aria-describedby": messageId, children: [_jsx("button", { type: "button", className: "fm-confirm-modal__backdrop", "aria-label": cancelLabel, disabled: locked, onClick: () => {
                    if (!locked) {
                        onCancel();
                    }
                } }), _jsxs("div", { className: "fm-confirm-modal__panel", children: [_jsx("h2", { id: titleId, className: "fm-confirm-modal__title", children: title }), _jsx("p", { id: messageId, className: "fm-confirm-modal__message", children: message }), _jsxs("div", { className: "fm-confirm-modal__actions", children: [_jsx(Button, { label: cancelLabel, variant: "ghost", disabled: locked, onClick: onCancel }), _jsx("div", { ref: confirmWrapRef, children: _jsx(Button, { label: confirmLabel, variant: confirmVariant, disabled: locked, onClick: () => {
                                        if (locked) {
                                            return;
                                        }
                                        setSubmitted(true);
                                        onConfirm();
                                    } }) })] })] })] }), document.body);
}
//# sourceMappingURL=ConfirmModal.js.map